<template>
  <div class="plk_design row">
    <div class="menu_components two columns">
      <Menu/>
      <div class="components">
        <div class="title">
          <span v-if="!searchingComponents">{{$t('designer.design.avaliableComponents')}}</span>
          <input class="search" v-if="searchingComponents" v-model="filterComponent"/>
          <i @click="searchingComponents=!searchingComponents" class="fas pull-right pt-2" :class="searchingComponents ? 'fa-times' : 'fa-search'"></i>
        </div>
        <div class="item" v-for="item in filterAvaliableComponents" :key="item.id" @click="addObjectInView(selectedPage, item.id)">
          {{item.name}}<i v-if="item.id.startsWith('http')" @click="deleteAvaliableComponent(item.id)" class="fas fa-trash-alt pt-2 ml-2"/>
        </div>
      </div>
    </div>
    <div class="viewer ten columns columns-center">
      <div class="window_creator" :class="{ 'full_screen': maximize.screen, 'browser_desktop': !maximize.screen && typeView === 1, 'browser_tablet': !maximize.screen && typeView === 2, 'browser_mobile': !maximize.screen && typeView === 3 }">
        <div class="address_bar justify_content_between">
          <div class="bar_dots mr-auto">
            <span class="maximize" :title="$t(maximize.screen ? 'designer.design.minimize' : 'designer.design.maximize')" @click="maximize.screen=!maximize.screen"></span>
            <a :href="selectedPage" :title="$t('designer.design.showNewPage')" target="_blank"><span class="openNewTab"></span></a>
          </div>
          <NavbarSelector class="navbar" @changedPage="realoadView"/>
          <div class="bar_icons ml-auto">
            <i @click="changeView(1)" :title="$t('designer.design.showDesktop')" class="fas fa-desktop" :class="{ 'selected': typeView === 1 }"></i>
            <i @click="changeView(2)" :title="$t('designer.design.showTablet')" class="fas fa-tablet-alt" :class="{ 'selected': typeView === 2 }"></i>
            <i @click="changeView(3)" :title="$t('designer.design.showMobile')" class="fas fa-mobile-alt" :class="{ 'selected': typeView === 3 }"></i>
          </div>
        </div>
        <div class="html_content">
          <object id="page" v-if="selectedPage" :data="selectedPage" width="100%" height="100%" type="text/html">
            {{$t('designer.design.imposibleLoadEditor')}}
          </object>
        </div>
        <!-- <Configuration :type="'AutoRefresh'" :initValue="{}"/> -->
        <!-- <Configuration :type="'BasicHtml'" :initValue="{}" @changeValue="changeValue"/> -->
      </div>
    </div>
    <div class="config_area ten columns" :class="{ 'show': showConfig, 'maximize': maximize.config, 'u-full-width': maximize.screen}">
      <i @click="showDoc=!showDoc" :class="showDoc ? 'fas fa-code' : 'fas fa-book'" :title="$t(showDoc ? 'designer.design.showCode' : 'designer.design.showDoc')"></i>
      <i :title="$t('designer.design.closeconfig')" @click="maximize.config=false;showConfig=false" class="fas fa-times pull-right mr-3 mt-1"></i>
      <i :title="$t(maximize.config ? 'designer.design.minimize' : 'designer.design.maximize')" @click="maximize.config=!maximize.config" :class="maximize.config ? 'fa-compress-alt' : 'fa-expand-alt'" class="fas pull-right mr-3 mt-1"></i>
      <div class="content">
        <Configuration class="mt-5" v-if="!showDoc && selectedObject" :type="selectedObject.type" :initValue="selectedObject" @changeValue="saveConfig"/>
        <Documentation v-if="showDoc && selectedObject" :type="selectedObject.type"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import i18n from './i18n'
import { DESIGN } from '@/store'
import Configuration from '@/components/creator/configuration/Index'
import Documentation from '@/components/creator/documentation/Index'
import NavbarSelector from './components/NavbarSelector/Index'
import Menu from './components/Menu/Index'
import { EDIT_OBJECT, MOVE_LEFT, MOVE_RIGHT, MOVE_UP, MOVE_DOWN, DELETE_OBJECT, CLONE_OBJECT } from './components/ObjectLoader/Index'

export default {
  name: 'design',
  components: {
    Configuration,
    Documentation,
    Menu,
    NavbarSelector
  },
  data () {
    return {
      typeView: 1,
      maximize: {
        screen: false,
        config: false
      },
      filterComponent: '',
      searchingComponents: false,
      showConfig: false,
      selectedObject: undefined,
      objectPosition: -1,
      selectedPage: undefined,
      showDoc: false
    }
  },
  computed: {
    avaliableComponents () {
      return this.$store.getters[DESIGN.GETTERS.GET_AVAILABLE_COMPONENTS]()
    },
    filterAvaliableComponents () {
      if (this.searchingComponents && this.filterComponent) {
        const filter = this.filterComponent.toLowerCase()
        return this.avaliableComponents.filter(e => e.name.toLowerCase().indexOf(filter) !== -1)
      } else {
        return this.avaliableComponents
      }
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      this.removeObjectListener()
      this.addObjectListener()
    },
    onDestroyComponent () {
      this.removeObjectListener()
    },
    addObjectListener () {
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      const eventer = window[eventMethod]
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
      eventer(messageEvent, this.objectListener)
    },
    removeObjectListener () {
      const eventMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent'
      const eventer = window[eventMethod]
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
      eventer(messageEvent, this.objectListener)
    },
    editComponent (position, component) {
      Vue.set(this, 'showConfig', !this.showConfig)
    },
    objectListener ({ data }) {
      if (data.type === EDIT_OBJECT) {
        Vue.set(this, 'objectPosition', data.position)
        Vue.set(this, 'selectedObject', Object.assign({}, data.object))
        this.editComponent(data.position, data.object)
      } else if (data.type === MOVE_LEFT || data.type === MOVE_UP) {
        this.moveComponent(data.position, data.position - 1)
      } else if (data.type === MOVE_RIGHT || data.type === MOVE_DOWN) {
        this.moveComponent(data.position, data.position + 1)
      } else if (data.type === DELETE_OBJECT) {
        this.deleteComponent(data.position)
      } else if (data.type === CLONE_OBJECT) {
        this.addComponent(data.object)
      }
    },
    addAvaliableComponent (id, name, image) {
      this.$store.commit({
        type: DESIGN.MUTATIONS.CREATE_AVAILABLE_COMPONENTS,
        id,
        name,
        image
      })
    },
    addObjectInView (view, id) {
      this.$store.commit({
        type: DESIGN.MUTATIONS.ADD_OBJECT,
        view,
        object: {
          type: id
        }
      })
      this.realoadView(this.selectedPage)
    },
    deleteAvaliableComponent (id) {
      if (id) {
        this.$modal.show('dialog', {
          title: this.$t('designer.design.deleteAvaliableComponents.title'),
          text: this.$t('designer.design.deleteAvaliableComponents.text'),
          buttons: [
            {
              title: this.$t('designer.design.deleteAvaliableComponents.modal.cancel')
            },
            {
              title: this.$t('designer.design.deleteAvaliableComponents.modal.confirm'),
              handler: () => {
                this.$store.commit({
                  type: DESIGN.MUTATIONS.DELETE_AVAILABLE_COMPONENTS,
                  id
                })
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      }
    },
    moveComponent (lastPosition, newPosition) {
      this.$store.commit({
        type: DESIGN.MUTATIONS.MOVE_OBJECT,
        view: this.selectedPage,
        lastPosition,
        newPosition
      })
      this.realoadView(this.selectedPage)
    },
    addComponent (object) {
      if (object) {
        this.$store.commit({
          type: DESIGN.MUTATIONS.ADD_OBJECT,
          view: this.selectedPage,
          object
        })
        this.realoadView(this.selectedPage)
      }
    },
    deleteComponent (position) {
      if (position !== undefined) {
        this.$modal.show('dialog', {
          title: this.$t('designer.design.deleteComponent.title'),
          text: this.$t('designer.design.deleteComponent.text'),
          buttons: [
            {
              title: this.$t('designer.design.deleteComponent.modal.cancel')
            },
            {
              title: this.$t('designer.design.deleteComponent.modal.confirm'),
              handler: () => {
                this.$store.commit({
                  type: DESIGN.MUTATIONS.DELETE_OBJECT,
                  view: this.selectedPage,
                  position
                })
                this.$modal.hide('dialog')
                this.realoadView(this.selectedPage)
              }
            }
          ]
        })
      }
    },
    realoadView (newPage) {
      Vue.nextTick(() => {
        Vue.set(this, 'selectedPage', undefined)
        Vue.nextTick(() => {
          Vue.set(this, 'selectedPage', newPage)
        })
      })
    },
    saveConfig ({ model }) {
      this.$store.commit({
        type: DESIGN.MUTATIONS.UPDATE_OBJECT,
        view: this.selectedPage,
        position: this.objectPosition,
        object: model
      })
      this.realoadView(this.selectedPage)
      Vue.set(this, 'showConfig', false)
    },
    changeView (type) {
      Vue.set(this, 'typeView', type)
    }
  }
}
</script>

<style scoped lang="scss">
.plk_design {
  background: #f8f9fa;
}
.menu_components {
  padding: 5px;
  background: #848e98;;
  height: 100vh;
  overflow: scroll;
  border-right: solid 1px #dee2e6;
}
.menu_components .components {
  margin-top: 5px;
  padding: 5px;
}
.menu_components .components .search:focus {
  outline-width: 0;
  padding-left: 5px;
}
.menu_components .components .search {
  border-radius: 10px;
  margin-bottom: 5px;
  width: 85%;
}
.menu_components .components .title {
  color: #011627;
  text-decoration: none;
  display: block;
  font-weight: bold;
  font-size: 0.9em;
}
.menu_components .components .item {
  padding-left: 5px;
  color: #f4f3ee;
  cursor: pointer;
}
.menu_components .components .item .fas {
  display: none;
}
.menu_components .components .item:hover .fas:hover {
  color: #a50000;
}
.menu_components .components .item:hover .fas {
  display: inline;
}
.menu_components .components .item:hover {
  color: #bac1b8;
}
.config_area {
  position: fixed;
  width: 86.5%;
  left: 9.33%;
  bottom: -70vh;
  height: 70vh;
  background: white;
  border-top: solid 1px #dee2e6;
  padding: 10px;
  -webkit-transition: bottom 1s ease;
  -moz-transition: bottom 1s ease;
  -ms-transition: bottom 1s ease;
  -o-transition: bottom 1s ease;
  transition: bottom 1s ease;
}
.config_area.u-full-width {
  width: 100%;
  left: 0;
  margin: 0;
}
.config_area.maximize {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
}
.config_area.show {
  bottom: 0;
}
.config_area .content {
  overflow: scroll;
  height: 100%;
}
.viewer {
  margin-top: 3vh;
  margin-left: 2%;
  margin-right: 2%;
}
.window_creator {
  height: 94vh;
  border: 1px solid #dee2e6!important;
  margin: auto;
  background: white;
}
.window_creator.full_screen {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  margin-top: 0;
}
.window_creator.full_screen .bar_icons {
  display: none;
}
.window_creator.full_screen .address_bar .navbar {
  margin-right: 25%;
}
.html_content {
  height: calc(100% - 43px);
  overflow: scroll;
}
.browser_desktop {
  width: 100%;
}
.justify_content_between {
  display: -webkit-box!important;
  display: -ms-flexbox!important;
  display: flex!important;
  -webkit-box-pack: justify!important;
  -ms-flex-pack: justify!important;
  justify-content: space-between!important;
}
.address_bar {
  height: 50px;
  padding: 0 14px;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6!important;
}
.bar_dots span {
  display: inline-block;
  width: 16px;
  height: 15px;
  border-radius: 50%;
  margin: 18px 8px 0 0;
  background-color: #dee2e6;
}
.bar_dots .maximize:hover {
  background: #68d268;
}
.bar_dots .openNewTab:hover {
  background: #ffaf19;
}
.fas {
  cursor: pointer;
}
.bar_dots span {
  cursor: pointer;
}
.bar_icons i:hover {
  color: #000000;
}
.bar_icons i.selected {
  color: black;
}
.bar_icons i {
  width: 16px;
  height: 15px;
  margin: 12px 4px 0 0;
  cursor: pointer;
  padding: 5px;
  color: #b5b5b5;
}
.address_bar .navbar {
  width: 50%;
}
@media (max-width: 550px) {
  .plk_design {
    display: flex;
    flex-flow: column;
  }
  .viewer {
    order: 2;
    margin: 0;
  }
  .menu_components {
    order: 1;
    height: 70vh;
  }
  .window_creator {
    height: 70vh;
    margin: 0;
  }
  .bar_dots,
  .bar_icons {
    display: none;
  }
  .address_bar .navbar {
    width: 100%;
  }
  .config_area {
    left: 0;
    width: 100%;
  }
}
@media (max-width: 1050px) {
  .menu_components .components .search {
    width: 60%;
  }
}
@media (min-width: 550px) {
  .viewer.ten.columns {
    width: 82.6666666667%;
  }
  .browser_tablet {
    width: 100%;
    max-width: 778px;
  }
  .browser_mobile {
    width: 100%;
    max-width: 375px;
  }
}
</style>
